import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const ListPageItem = styled(Link)`
    background: var(--item-list-background);
    padding: 30px;
    display: block;
    color: #000000;
    &:hover {
        background: #ebebed;
        text-decoration: none;
    }
    border-radius: 6px;
    margin-bottom: 29px;
    min-height: 124px;

    @media (max-width: 576px) {
        padding: 25px 15px;
    }
`;
